import React from "react";
import { Divider, Typography } from "antd";

interface ResumeSummaryProps {
  summary: string;
}

const ResumeSummary: React.FC<ResumeSummaryProps> = ({ summary }) => {
  return (
    <div className="resume-preview-card">
      <div className="resume-preview-card-header">
        <div className="resume-preview-card-header-title">
          <span className="material-symbols-outlined">text_snippet</span>
          <Typography.Text strong>Profile Summary</Typography.Text>
        </div>
      </div>
      <Divider style={{ margin: 0 }} />
      <Typography.Paragraph>{summary}</Typography.Paragraph>
    </div>
  );
};

export default ResumeSummary;
